import React from 'react';
import DateSelect from '@op/components/FilterCommon/widgets/DateSelect';
import { useState } from 'react';
import { Switch } from 'tea-component';
import { useIntl } from 'umi';
import { DateType } from '../../types';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';

export default function CompareDateSelect(props: DateType) {
  const [value, setValue] = useState(false);
  const { formatMessage } = useIntl();

  return (
    <div className="compare-date-select-wrapper">
      <Switch
        onChange={(val: boolean) => {
          setValue(val);
          buriedBtnPoint('DateTypeSwitch', value ? 'Release' : 'General');
        }}
      >
        {formatMessage({ id: 'Align to Release' })}
      </Switch>
      <DateSelect {...props} useLaunchTime={value}></DateSelect>
    </div>
  );
}
